
import { Component, Prop, Vue } from 'vue-property-decorator';
import StdForm from '@shared/components/forms/auto-form/std-form/std-form.vue';
import EntityFormProvider from '@shared/components/forms/auto-form/entity-form-provider/entity-form-provider.vue';
import { ActivitySessionAttendee } from '@activities/interfaces/activity-session-attendee';

@Component({
  name: 'bpc-activity-session-attendee-form',
  components: {
    'bpc-std-form': StdForm,
  },
})
export default class ActivitySessionAttendeeForm extends Vue {
  $refs: {
    // resourceForm: InstanceType<typeof ResourceForm> & { saveEntity(): void };
    stdForm: InstanceType<typeof StdForm> & {
      saveEntity(): void;
      formModel: any;
      searchEntity(): void;
      formProvider: EntityFormProvider;
    };
  };

  @Prop([String, Number]) readonly entityId: string | number;
  @Prop({ type: String, default: 'default' }) formConfigName: string;
  @Prop({ type: Boolean, default: false }) disabled: boolean;
  @Prop(Object) readonly externalFormModel: any;
  @Prop(Object) readonly extraData: any;

  public entityName = 'activity-session-attendee';
  public permissionEntityNameToUse = 'activity_session_attendees';
  public formModel: ActivitySessionAttendee = null;
  private modelLoaded;
  private previousPriceParameters;

  mounted(): void {
    this.$root.$on('updateAttendeePrice', () => {
      this.setAttendeePrice();
    });
  }

  destroyed(): void {
    this.$root.$off('updateAttendeePrice');
  }

  onFormSaved(event) {
    this.$emit('entity-saved', event);
  }

  onSavingEntity(event) {
    this.$emit('saving-entity', event);
  }

  onModelLoaded(event) {
    this.modelLoaded = JSON.parse(JSON.stringify(this.$refs.stdForm?.formModel));
    this.$emit('model-loaded', event);
  }

  saveEntity() {
    this.$refs.stdForm.saveEntity();
  }

  private setAttendeePrice() {
    setTimeout(() => {
      const articleID = this.$refs.stdForm?.formModel?.article?.id;
      const priceCategoryID = this.$refs.stdForm?.formModel?.price_category?.id;
      const date =
        this.$refs.stdForm?.formModel?.activitySession?.date ||
        this.extraData.externalFormModel.date;

      console.log(`articleId = ${articleID}, priceCategoryId = ${priceCategoryID}, date = ${date}`);
      const newPriceParameters = [articleID, priceCategoryID, date].join(',');

      if (articleID && date && newPriceParameters !== this.previousPriceParameters) {
        this.previousPriceParameters = newPriceParameters;
        const basePath = this.$bpcApiRouteHelper.getEntityPath('activity-session-attendees');
        this.$bpcApi
          .post(basePath + '/attendee-price', {
            articleId: articleID,
            priceCategoryId: priceCategoryID,
            date: date,
          })
          .subscribe(
            res => {
              this.$set(
                this.$refs.stdForm.formModel,
                'attendee_price',
                Number(res.data).toFixed(2),
              );
            },
            error => {
              console.log(error);
            },
          );
      } else {
        console.log('No price calculation necessary');
        this.previousPriceParameters = newPriceParameters;
      }
    }, 600);
  }
}
